import { render, staticRenderFns } from "./upgrade_modal.vue?vue&type=template&id=006f4674&scoped=true&"
import script from "./upgrade_modal.vue?vue&type=script&lang=js&"
export * from "./upgrade_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006f4674",
  null
  
)

export default component.exports